import * as React from 'react';

import { IconToastExclamation36, IconToastSuccessful36 } from '@nebula/icon';

import { ToastProps } from '@shopee-user/business-customization-types';

import styles from './style.scss';

const ICON_MAPPING = {
  success: IconToastSuccessful36,
  warning: IconToastExclamation36,
};

export function Toast({ text, level }: ToastProps) {
  const Icon = ICON_MAPPING[level];
  return (
    <div className={styles.toastBox}>
      <Icon className={styles.icon} />
      <p className={styles.text}>{text}</p>
    </div>
  );
}
